import React from 'react';

const CardRibbon = ({ children, className }) => {
  return (
    <div className={`ribbon absolute w-32 h-32 overflow-hidden -top-2 -right-2 ${className}`}>
      <span className="absolute border-light-700 border-solid border-4" />
      <span className="font-serifdisplay z-10 shadow-md capitalize absolute w-48 h-12 px-4 py-0 text-white bg-light-500 transform rotate-45 flex justify-center items-center top-6 -left-4 font-bold">
        {children}
      </span>
      <span className="absolute border-light-700 border-solid border-4 right-0 bottom-0" />
    </div>
  );

  // return (
  //   <div
  //     className={`flex justify-center items-center bg-light-500 text-white font-serifdisplay font-bold py-1 pr-2 pl-4 rounded-l-full ${className}`}
  //   >
  //     {children}
  //   </div>
  // );
};

export default CardRibbon;
